/**
 * ProtectedRoute — Wrapper für rollengeschützte Seiten (LEH-002, Authentik
 * seit issue #6).
 *
 * Nicht angemeldet → direkt zum IdP weiterleiten (signIn), KEINE Zwischenseite
 * mit Button. So landet man beim Aufruf einer geschützten Seite sofort auf der
 * Authentik-Anmeldung.
 */

import { ReactNode, useEffect } from "react"
import { Navigate } from "react-router-dom"

import { useAuth } from "@/hooks/useAuth"

interface ProtectedRouteProps {
  children: ReactNode
  /** Optional erforderliche App-Rolle (z. B. "admin"). */
  role?: string
}

export function ProtectedRoute({ children, role }: ProtectedRouteProps) {
  const { oidcAuth, oidcLoading, hasRole, login } = useAuth()

  // Nicht angemeldet → automatisch zur Authentik-Anmeldung (ohne Extra-Klick).
  useEffect(() => {
    if (!oidcLoading && !oidcAuth) {
      login()
    }
  }, [oidcLoading, oidcAuth, login])

  if (oidcLoading || !oidcAuth) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Weiterleitung zur Anmeldung…
      </div>
    )
  }

  if (role && !hasRole(role)) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
